import { Link } from "react-router-dom";
import { Input } from "antd";
import { useRef } from "react";
import { useQuery } from "@tanstack/react-query";
import ContentLayout from "../layout/ContentLayout";
import { getAllRewards } from "../../actions/acc_actions";
import Loading from "../../utils/Loading";
import OutletCard from "../OutletCard";
import MyModal from "../MyModal";
import Button from "../Button";

export default function Rewards({ businessUrn }) {
  const modalRef = useRef();

  const { isLoading, data } = useQuery({
    queryKey: ["rewards", businessUrn],
    queryFn: () => getAllRewards(businessUrn),
    enabled: !!businessUrn,
  });

  if (isLoading) return <Loading />;

  const rewards = data?.data;
  const isEmpty = !(rewards?.length > 0);

  const handleEdit = () => {
    modalRef.current.showModal();
  };

  const handleDelete = () => {
    // console.log("Delete clicked");
  };

  const handleAddStampDevice = () => {
    // console.log("Add Stamp Device clicked");
  };

  return (
    <ContentLayout
      header={
        isEmpty ? (
          <div className="screen-notification">
            <img src="/assets/images/bg/rewards.png" alt="" />
            <h2 className="active">No Reward yet?</h2>
            <h5>
              Reward your customers with exclusive offers as they collect stamps
              on their journey to loyalty.
            </h5>
            <Link className="btn primary" to="add">
              Add Your First Reward
            </Link>
          </div>
        ) : (
          <>
            <h1>
              Welcome to <span>Rewards</span>
            </h1>
          </>
        )
      }
      bodyVariant="transparent"
    >
      {!isEmpty && (
        <>
          <div className="features-tab">
            <div className="form-row">
              <Link to="create" className="btn primary">
                Create
              </Link>
            </div>

            <div
              style={{ display: "flex", flexDirection: "column", gap: "2rem" }}
            >
              {rewards?.map((reward) => (
                <OutletCard
                  key={reward.urn} // Unique key is important
                  businessName={reward.name || "Reward Name"} // fallback if name missing
                  locationHint={
                    reward.stamp_count
                      ? `${reward.stamp_count} Stamps`
                      : "No Stamps Info"
                  }
                  created={reward.created}
                  onAddStampDevice={handleAddStampDevice}
                  onEdit={handleEdit}
                  onDelete={handleDelete}
                  showAddStampDevice={false}
                  showDelete={false}
                />
              ))}
            </div>
            <MyModal
              ref={modalRef}
              title="Add Stamp Code"
              message="Add Your Stamp Device Code To Connect To Your outlet"
              imageSrc="/assets/images/modal/stamp.png"
              additionalContent={
                <>
                  <Input className="" />
                  <Button> Add</Button>
                  {
                    <div className="list">
                      <h6>Stamps Decice Code</h6>
                      <div className="row">
                        <h5 className="stamp-code">#5646528</h5>
                        <Button variant="secondary">Delete</Button>
                      </div>
                    </div>
                  }
                </>
              }
            />
          </div>
        </>
      )}
    </ContentLayout>
  );
}
